var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-holder"},[_c('h1',[_vm._v("4"),_c('span',[_vm._v("0")]),_vm._v("4")])])
}]

export { render, staticRenderFns }